// src/components/ConflictIndicator.jsx
import React from 'react';
import HelpIcon from './Documentation/HelpIcon';

// Warning Icon SVG - updated to match other floating buttons
const WarningIcon = ({ hasConflicts }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
    </svg>
);

function ConflictIndicator({ conflictCount = 0, onClick }) {
    const hasConflicts = conflictCount > 0;

    // Base styles - updated to match other floating buttons
    const baseStyle = "p-4 rounded-full shadow-lg flex items-center justify-center cursor-pointer transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
    // Conditional styles based on conflicts - light grey background, icon color changes
    const conflictStyle = hasConflicts
        ? "bg-gray-200 hover:bg-gray-300 text-red-600"
        : "bg-green-600 hover:bg-green-700 text-white";

    return (
        <div className="relative">
            <button
                onClick={onClick}
                className={`${baseStyle} ${conflictStyle}`}
                title={`${conflictCount} conflict${conflictCount !== 1 ? 's' : ''} detected. Click to view.`}
                aria-label={`Show ${conflictCount} schedule conflicts`}
            >
                {/* Icon */}
                <WarningIcon hasConflicts={hasConflicts} />

                {/* Badge - updated positioning to match other buttons */}
                {hasConflicts && (
                    <span
                        className="absolute -top-1 -right-1 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full"
                    >
                        {conflictCount}
                    </span>
                )}
            </button>
            <HelpIcon
                documentationId="conflict-indicator"
                size={14}
                position="relative"
                className="bg-transparent text-gray-600 rounded-full p-1 bottom-[-12px] -left-2 z-10"
            />
        </div>
    );
}

export default ConflictIndicator;